export const themePathFor = theme => {
  const parentTheme = theme?.parent;
  const parentParentTheme = parentTheme?.parent;

  const rootTheme = parentParentTheme || parentTheme || theme;
  const subTheme = (parentParentTheme && parentTheme) || (parentTheme && theme);
  const finalTheme = parentParentTheme && parentTheme && theme;

  return { rootTheme, subTheme, finalTheme };
};
